module.exports = __webpack_public_path__ + "img/logo_horizontal.bacbcd37.png";